import React, { useEffect }  from "react";
import { 
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from 'recoil';
import { alertState } from 'src/recoil/atoms/global';
import { useMutation, useQuery } from "src/Hooks/useReactQuery";
import { updateWebhookConfig, getWebhookConfig } from "src/services/auth";
import { useForm } from "react-hook-form";
import FormInput from "src/components/Common/Form/FormInput";
import { PATTERN_URL } from "src/constant/common";

const FORM_NAME = {
  WORKFLOW_URL: "webhook_url"
};

const ModalSettings = ({toggle, closeModal}) => {
  const { t } = useTranslation("topbar");
  const showAlert = useSetRecoilState(alertState);

  const updateWebhookConfigMutate = useMutation({
    mutationFn: ({data}) => updateWebhookConfig({data}),
  });

  const { data: webhookConfigData } = useQuery({
    queryKey: ["webhookConfig"],
    queryFn: () => getWebhookConfig(),
    enabled: toggle,
    refetchOnWindowFocus: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch
  } = useForm({
    defaultValues: {},
  });

  const trackUrl = watch(FORM_NAME.WORKFLOW_URL);
  
  const handleSubmitForm = async (data) => {

    try {
      await updateWebhookConfigMutate.mutateAsync({ data });
      closeModal();
      showAlert({
        status: true,
        message: t("modal.setting.save_success"),
        type: "success",
      });
    } catch (error) {
      console.error("Error save setting:", error);
    }
  };

  useEffect(() => {
    if (toggle) {
      reset({
        [FORM_NAME.WORKFLOW_URL]: webhookConfigData?.webhook_url || "",
      });
    }
  }, [toggle, reset, webhookConfigData]);

  return (
    <>
      <Modal centered isOpen={toggle} toggle={closeModal} size="lg" backdrop="static">
        <ModalHeader toggle={closeModal} className="bg-skin-primary text-white">
          {t("modal.setting.title")}
        </ModalHeader>
        <ModalBody className="overflow-auto">
          <div className="row">
            <div className="col-md-12">
              <FormInput
                register={register}
                label={t("modal.setting.webhook_url")}
                name={FORM_NAME.WORKFLOW_URL}
                placeholder={t("modal.setting.webhook_url_placeholder")}
                errors={errors?.[FORM_NAME.WORKFLOW_URL]?.message}
                maxLength={255}
                maxLengthMessage={t("modal.setting.webhook_url_maxlength")}
                pattern={{
                  value: PATTERN_URL,
                  message: t("modal.setting.webhook_url_invalid"),
                }}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center mb-3">
          <Button
            className="btn btn-sm btn-primary m-x-10 width-by-px-120"
            color="primary"
            onClick={handleSubmit((data) => handleSubmitForm(data))}
            disabled={updateWebhookConfigMutate.isLoading || !trackUrl}
          >
            {t("button.save")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalSettings;
